import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
const VARIANT_CLASS = {
    primary: 'sec-btn--primary',
    secondary: 'sec-btn--secondary',
    outline: 'sec-btn--outline',
    ghost: 'sec-btn--ghost',
    accent: 'sec-btn--accent',
    danger: 'sec-btn--danger',
    'on-dark': 'sec-btn--on-dark',
};
const SIZE_CLASS = {
    sm: 'sec-btn--sm',
    md: null,
    lg: 'sec-btn--lg',
};
/**
 * Button auf Basis der Design-System-Klassen (`.sec-btn`). Liefert konsistentes
 * Verhalten und A11y (nativer `<button>`, `type` default `button`, damit er
 * nicht ungewollt Formulare absendet).
 */
export const Button = forwardRef(function Button({ variant = 'primary', size = 'md', icon = false, block = false, type = 'button', className, ...rest }, ref) {
    return (_jsx("button", { ref: ref, type: type, className: cn('sec-btn', VARIANT_CLASS[variant], SIZE_CLASS[size], icon && 'sec-btn--icon', block && 'sec-btn--block', className), ...rest }));
});
